
import { SET_LINEUPFREQ_DATA } from "../actions/action_lineupfreq";
import { SET_LINEUPFREQ_SHOWLOADER } from "../actions/action_lineupfreq";

const initialState = {
  data: [],
  numRows: 0,
  showLoader: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LINEUPFREQ_DATA:
      var newState = {
        data: action.payload,
        numRows: action.payload.length,
        showLoader: false
      };
      return { ...state, ...newState };
    case SET_LINEUPFREQ_SHOWLOADER:
      return { ...state, showLoader: action.payload };
    default:
      return state;
  }
}
